function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.82311 6.16016H1.63164C0.732579 6.16016 0 6.89272 0 7.79179V14.1518C0 14.618 0.299688 15.0509 0.74922 15.2008C2.36421 15.7335 4.04579 15.9999 5.72738 15.9999C7.40896 15.9999 9.09054 15.7335 10.7055 15.2008C11.1551 15.0509 11.4548 14.6347 11.4548 14.1518V7.79179C11.4548 6.89272 10.7222 6.16016 9.82311 6.16016ZM6.52654 11.0051V12.6368C6.52654 13.0696 6.16026 13.4359 5.72738 13.4359C5.29449 13.4359 4.92821 13.0696 4.92821 12.6368V11.0051C4.49533 10.7387 4.21229 10.2559 4.21229 9.70646C4.21229 8.874 4.89491 8.19138 5.72738 8.19138C6.55984 8.19138 7.24246 8.874 7.24246 9.70646C7.24246 10.2559 6.95942 10.7387 6.52654 11.0051Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.28011 4.17898C3.28011 2.83038 4.37897 1.73153 5.72756 1.73153C7.07616 1.73153 8.17502 2.83038 8.17502 4.17898V5.82727H9.90654V4.17898C9.90654 1.88137 8.02517 0 5.72756 0C3.42995 0 1.54858 1.88137 1.54858 4.17898V5.82727H3.28011V4.17898Z",
  fill: "currentColor"
});

function SvgSecurityv2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityv2);
export default __webpack_public_path__ + "static/media/securityv2.14705d63.svg";
export { ForwardRef as ReactComponent };